import { useState } from "react";
import { faqs } from "@/mocks/chigua";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-24 bg-background-100 py-14 md:py-20">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-4 md:px-6 lg:grid-cols-[0.8fr_1.2fr] lg:gap-14">
        <div>
          <p className="num-tab mb-3 text-xs tracking-[0.3em] text-primary-600">FAQ · 常见问题</p>
          <h2 className="font-heading text-3xl font-bold leading-snug tracking-wide text-foreground-950 md:text-4xl">
            关于吃瓜大赛，<br />
            <span className="text-primary-600">你想知道的都在这里</span>
          </h2>
          <p className="mt-5 max-w-md text-sm leading-7 text-foreground-600">
            第一次围观的朋友常问的问题，我们一并整理好了。如果还有疑问，欢迎滑到下方“提交你的瓜”给我们留言。
          </p>
          <a
            href="#join"
            className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-foreground-950 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
          >
            还有问题？联系我们
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((f, i) => {
            const open = openIdx === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-2xl bg-background-50 ring-1 transition-all ${
                  open ? "ring-primary-300" : "ring-background-200"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
                >
                  <span className="flex items-center gap-3">
                    <span
                      className={`num-tab flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs ${
                        open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                      }`}
                    >
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <h3 className="text-[15px] font-medium text-foreground-950">{f.q}</h3>
                  </span>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-lg transition-transform ${
                      open ? "rotate-45 bg-primary-100 text-primary-600" : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    <i className="ri-add-line" />
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ${open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 pl-[52px] pr-8 text-sm leading-7 text-foreground-600 md:px-6 md:pl-[64px]">
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}